var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import orderBy from 'lodash/orderBy';
import { RESPONSE_STATUS } from './models';
import { getInitialState } from './reducer';
import { createSelector } from 'reselect';
import { selectIntegrations } from '../../containers/StructureBuilderPage/selectors';
var selectLogicBuilderDomain = function (state) { return (state && state.logicBuilder) || getInitialState(); };
export var selectSelectedCustomLogicId = createSelector(selectLogicBuilderDomain, function (domain) { return domain.selectedCustomLogicId; });
export var selectPropertiesBarVisibility = createSelector(selectLogicBuilderDomain, function (domain) { return domain.propertiesBarState; });
export var selectDeleteConfirmationModalVisibility = createSelector(selectLogicBuilderDomain, function (domain) { return domain.deleteConfirmationModalState; });
export var selectDuplicateConfigModalVisibility = createSelector(selectLogicBuilderDomain, function (domain) { return domain.isDuplicateConfigModalVisible; });
export var selectDynamicModalVisibility = createSelector(selectLogicBuilderDomain, function (domain) { return domain.dynamicModalState; });
export var selectCanvasSelection = createSelector(selectLogicBuilderDomain, function (domain) { return domain.isCanvasSelected; });
export var selectSelectedEntity = createSelector(selectLogicBuilderDomain, function (domain) { return domain.selectedEntity; });
export var selectCanvasOffset = createSelector(selectLogicBuilderDomain, function (domain) { return domain.canvasOffset; });
export var selectOutputParamSync = createSelector(selectLogicBuilderDomain, function (domain) { return domain.outputParamSync; });
export var selectCustomLogicToDelete = createSelector(selectLogicBuilderDomain, function (domain) { return domain.customLogicToDelete; });
export var selectCustomLogicState = createSelector(selectLogicBuilderDomain, function (domain) { return domain.customLogic; });
export var selectViewState = createSelector(selectCustomLogicState, function (customLogic) {
    var _a, _b, _c, _d;
    if (((_a = customLogic.read) === null || _a === void 0 ? void 0 : _a.status) === RESPONSE_STATUS.IDLE &&
        ((_b = customLogic.readAll) === null || _b === void 0 ? void 0 : _b.status) === RESPONSE_STATUS.IDLE) {
        return 'init';
    }
    else if (((_c = customLogic.read) === null || _c === void 0 ? void 0 : _c.status) === RESPONSE_STATUS.LOADING ||
        ((_d = customLogic.readAll) === null || _d === void 0 ? void 0 : _d.status) === RESPONSE_STATUS.LOADING) {
        return 'loading';
    }
    else {
        return 'normal';
    }
});
export var selectLoadingState = createSelector(selectCustomLogicState, function (customLogic) {
    var _a, _b, _c, _d;
    var getLoadingType = function () {
        var _a, _b, _c, _d;
        if (((_a = customLogic.create) === null || _a === void 0 ? void 0 : _a.status) === RESPONSE_STATUS.LOADING) {
            return 'Creating Custom Logic';
        }
        if (((_b = customLogic.delete) === null || _b === void 0 ? void 0 : _b.status) === RESPONSE_STATUS.LOADING) {
            return 'Deleting Custom Logic';
        }
        if ([(_c = customLogic.read) === null || _c === void 0 ? void 0 : _c.status, (_d = customLogic.readAll) === null || _d === void 0 ? void 0 : _d.status].includes(RESPONSE_STATUS.LOADING)) {
            return 'Loading Custom Logic';
        }
        return '';
    };
    return {
        isLoading: [
            (_a = customLogic.create) === null || _a === void 0 ? void 0 : _a.status,
            (_b = customLogic.read) === null || _b === void 0 ? void 0 : _b.status,
            (_c = customLogic.readAll) === null || _c === void 0 ? void 0 : _c.status,
            (_d = customLogic.delete) === null || _d === void 0 ? void 0 : _d.status,
        ].includes(RESPONSE_STATUS.LOADING),
        loadingPhrase: getLoadingType(),
    };
});
export var selectCustomLogicCreateState = createSelector(selectCustomLogicState, function (customLogic) { var _a; return (_a = customLogic === null || customLogic === void 0 ? void 0 : customLogic.create) !== null && _a !== void 0 ? _a : { data: undefined, status: RESPONSE_STATUS.IDLE }; });
export var selectCustomLogicCreateData = createSelector(selectCustomLogicCreateState, function (subState) { return subState.data; });
export var selectCustomLogicCreateStatus = createSelector(selectCustomLogicCreateState, function (subState) { return subState.status; });
export var selectCustomLogicReadState = createSelector(selectCustomLogicState, function (customLogic) {
    var _a, _b, _c, _d, _e, _f;
    var modifiedPatches = (_c = (_b = (_a = customLogic.read) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.patches) === null || _c === void 0 ? void 0 : _c.map(function (patch) {
        var _a, _b, _c;
        if (patch.id === ((_b = (_a = customLogic.read) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.entrypoint)) {
            return __assign(__assign({}, patch), { logic: (_c = patch === null || patch === void 0 ? void 0 : patch.logic) !== null && _c !== void 0 ? _c : 'input', deletable: false });
        }
        return patch;
    });
    return {
        status: (_e = (_d = customLogic.read) === null || _d === void 0 ? void 0 : _d.status) !== null && _e !== void 0 ? _e : RESPONSE_STATUS.IDLE,
        data: __assign(__assign({}, (_f = customLogic.read) === null || _f === void 0 ? void 0 : _f.data), { patches: modifiedPatches }),
    };
});
export var selectCurrentCustomLogic = createSelector(selectCustomLogicReadState, selectIntegrations, function (customLogic, integrations) {
    var _a, _b, _c;
    var blocks = (_c = ((_b = (_a = customLogic.data) === null || _a === void 0 ? void 0 : _a.patches) !== null && _b !== void 0 ? _b : [])) === null || _c === void 0 ? void 0 : _c.map(function (block) {
        var _a;
        if ((block === null || block === void 0 ? void 0 : block.logic) === 'integration') {
            var integration = integrations.find(function (i) { var _a; return i.id === ((_a = block === null || block === void 0 ? void 0 : block.settings) === null || _a === void 0 ? void 0 : _a.integrationId); });
            if (integration) {
                var _b = integration.methods, methods = _b === void 0 ? [] : _b;
                var method = methods.find(function (m) { return m.id === (block === null || block === void 0 ? void 0 : block.settings.methodId); });
                if (method) {
                    var _c = method.status_codes, statusCodes = _c === void 0 ? [] : _c;
                    var mappedOutputs = __spreadArray(__spreadArray([], ((block === null || block === void 0 ? void 0 : block.outputs) || []), true), statusCodes.map(function (sc) { return ({ name: sc.name, type: 'event' }); }), true).reduce(function (acc, output) {
                        var _a;
                        if (output) {
                            var tempOutput = __assign({}, output);
                            if (!((_a = tempOutput === null || tempOutput === void 0 ? void 0 : tempOutput.name) === null || _a === void 0 ? void 0 : _a.includes('out:'))) {
                                tempOutput.name = "out:".concat(tempOutput.name);
                            }
                            acc[tempOutput.name] = tempOutput;
                        }
                        return acc;
                    }, {});
                    var outputs = Object.values(mappedOutputs);
                    return __assign(__assign({}, block), { outputs: outputs });
                }
            }
        }
        if (block.logic === 'async_logic') {
            if ((_a = block.settings.output_nodes) === null || _a === void 0 ? void 0 : _a.length) {
                var mappedOutputs = __spreadArray(__spreadArray([], (block.outputs || []), true), block.settings.output_nodes.map(function (opn) { return ({
                    name: opn.name,
                    type: 'event',
                }); }), true).reduce(function (acc, output) {
                    var _a;
                    if (output) {
                        var tempOutput = __assign({}, output);
                        if (!((_a = tempOutput === null || tempOutput === void 0 ? void 0 : tempOutput.name) === null || _a === void 0 ? void 0 : _a.includes('out:'))) {
                            tempOutput.name = "out:".concat(tempOutput.name);
                        }
                        acc[tempOutput.name] = tempOutput;
                    }
                    return acc;
                }, {});
                var outputs = Object.values(mappedOutputs);
                return __assign(__assign({}, block), { outputs: outputs });
            }
        }
        return block;
    });
    return __assign(__assign({}, customLogic.data), { patches: blocks });
});
export var selectCurrentCustomLogicStatus = createSelector(selectCustomLogicReadState, function (customLogic) { return customLogic.status; });
export var selectSelectedBlock = createSelector(selectCurrentCustomLogic, selectSelectedEntity, function (selectedLogic, selectedEntity) {
    var _a;
    return (_a = selectedLogic === null || selectedLogic === void 0 ? void 0 : selectedLogic.patches) === null || _a === void 0 ? void 0 : _a.find(function (block) {
        return (selectedEntity === null || selectedEntity === void 0 ? void 0 : selectedEntity.type) === 'block' && block.id === selectedEntity.id;
    });
});
export var selectSelectedConnector = createSelector(selectCurrentCustomLogic, selectSelectedEntity, function (selectedLogic, selectedEntity) {
    var _a;
    return (_a = selectedLogic === null || selectedLogic === void 0 ? void 0 : selectedLogic.edges) === null || _a === void 0 ? void 0 : _a.find(function (connector) {
        return (selectedEntity === null || selectedEntity === void 0 ? void 0 : selectedEntity.type) === 'connector' &&
            connector.id === selectedEntity.id;
    });
});
export var selectCustomLogicReadAllState = createSelector(selectCustomLogicState, function (customLogic) {
    var _a, _b;
    return (customLogic === null || customLogic === void 0 ? void 0 : customLogic.readAll)
        ? __assign(__assign({}, customLogic.readAll), { data: (_b = (_a = customLogic.readAll) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [] }) : { data: undefined, status: RESPONSE_STATUS.IDLE };
});
export var selectAllCustomLogics = createSelector(selectCustomLogicReadAllState, function (subState) { var _a; return orderBy((_a = subState.data) !== null && _a !== void 0 ? _a : [], 'updated_at', 'desc'); });
export var selectCustomLogicDeleteStatus = createSelector(selectCustomLogicState, function (customLogic) {
    var _a, _b;
    return (_b = (_a = customLogic === null || customLogic === void 0 ? void 0 : customLogic.delete) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : RESPONSE_STATUS.IDLE;
});
export var selectBlockState = createSelector(selectLogicBuilderDomain, function (domain) { return domain.block; });
export var selectBlockCreateState = createSelector(selectBlockState, function (block) { var _a; return (_a = block.create) !== null && _a !== void 0 ? _a : { data: undefined, status: RESPONSE_STATUS.IDLE }; });
export var selectBlockCreateStatus = createSelector(selectBlockCreateState, function (subState) { return subState.status; });
export var selectBlockUpdateState = createSelector(selectBlockState, function (block) {
    var _a;
    return (_a = block.update) !== null && _a !== void 0 ? _a : {
        data: undefined,
        status: RESPONSE_STATUS.IDLE,
        ref: '',
    };
});
export var selectBlockUpdateStatus = createSelector(selectBlockUpdateState, function (subState) { return subState.status; });
export var selectBlockDeleteState = createSelector(selectBlockState, function (block) {
    var _a;
    return (_a = block.delete) !== null && _a !== void 0 ? _a : {
        data: undefined,
        status: RESPONSE_STATUS.IDLE,
        ref: '',
    };
});
export var selectBlockDeleteStatus = createSelector(selectBlockDeleteState, function (subState) { return subState.status; });
export var selectBlockDuplicateStatus = createSelector(selectBlockState, function (block) { var _a, _b; return (_b = (_a = block.duplicate) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : RESPONSE_STATUS.IDLE; });
export var selectConnectorState = createSelector(selectLogicBuilderDomain, function (domain) { return domain.connector; });
export var selectConnectorCreateState = createSelector(selectConnectorState, function (connector) { var _a; return (_a = connector.create) !== null && _a !== void 0 ? _a : { data: undefined, status: RESPONSE_STATUS.IDLE }; });
export var selectConnectorCreateStatus = createSelector(selectConnectorCreateState, function (subState) { return subState.status; });
export var selectAppOptionListState = createSelector(selectLogicBuilderDomain, function (domain) { return domain.appOptionList; });
export var selectDuplicateCustomLogicState = createSelector(selectLogicBuilderDomain, function (domain) { return domain.customLogicDuplicateState; });
export var selectLogicBuilderSavingState = createSelector(selectLogicBuilderDomain, function (domain) { return domain.isSavingChanges; });
export var selectCustomLogicSubscription = createSelector(selectLogicBuilderDomain, function (domain) { return domain.customLogicSubscription; });
